import dayjs, { type Dayjs } from 'dayjs'

import { preserveDateInTimezone } from 'common/services/dateService'

export const SITE_DATE_FORMAT = 'YYYY-MM-DD'
export const SITE_TIME_FORMAT = 'HH:mm'

// Pickers show and hand back site wall-clock digits; no instant is involved.
export const toPickerDate = (date: string, timeZone: string | undefined): Dayjs | null =>
  date ? preserveDateInTimezone(date, timeZone) : null

export const fromPickerDate = (value: Dayjs, timeZone: string | undefined): string =>
  preserveDateInTimezone(value, timeZone).format(SITE_DATE_FORMAT)

// A fixed day with no DST change, so every HH:mm exists in the browser's zone too.
const TIME_ANCHOR_DAY = '2000-01-03'

// A time-only picker needs a day to hang on; the digits are all that is read back.
export const toPickerTime = (time: string): Dayjs | null =>
  time ? dayjs(`${TIME_ANCHOR_DAY}T${time}`) : null

export const fromPickerTime = (value: Dayjs): string => value.format(SITE_TIME_FORMAT)
